// @material-ui/core
import { Grid, Typography } from "@material-ui/core";
import React, { Component } from "react";
import AppCard from "../../library/card/AppCard";
import CustomerCard from "../../library/card/CustomerCard";
import LicenseCard from "../../library/card/LicenseCard";
import FullDialog from "../../library/dialog/FullDialog";
import Caba from "../../services/Caba";
import Button from "../button/MainButton";

export const styles = theme => ({
  control: {
    width: "100%"
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    minWidth: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

export function withPage(WrappedComponent) {
  return class extends Component {
    state = {
      objects: [],
      isOpen: false,
      newObject: null
    };

    componentDidMount() {
      this.props.toggleLoading(true);
      this.init();
    }

    init = () => {
      // make a call
      Caba.get(`/api/v1/${this.props.slug}`).then(response => {
        this.props.toggleLoading(false);
        this.setState({
          objects: response.data
        });
      });
    };

    handleChange = newObject => {
      this.setState({ newObject });
    };

    toggleOpen = isOpen => {
      this.setState({ isOpen });
    };

    handleAction = () => {
      this.toggleOpen(false);
      this.props.toggleLoading(true);

      // @TODO: Route checken, die muss noch genau definiert werden
      Caba.post(`/api/v1/${this.props.slug}`, this.state.newObject)
        .then(response => {
          this.props.notify("success", response.status, "Created");
          this.init();
        })
        .catch(error => {
          console.log("error", error);
          this.props.toggleLoading(false);
          this.props.history.push(`/${this.props.slug}`);
        });
    };

    render() {
      const { objects } = this.state;
      const { slug } = this.props;

      const listItems = objects.map(object => {
        let Card;
        const cardProps = {
          object,
          key: object.id,
          isExpandable: true,
          slug,
          id: object.id,
          title: object.name ? object.name : object.id
        };
        switch (slug) {
          case "apps":
            Card = <AppCard {...cardProps} {...this.props} slug="apps" />;
            break;

          case "licenses":
            Card = (
              <LicenseCard {...cardProps} {...this.props} slug="licenses" />
            );
            break;

          case "customers":
            Card = (
              <CustomerCard {...cardProps} {...this.props} slug="customers" />
            );
            break;

          default:
            break;
        }

        return (
          <Grid item xs={12} key={object.id}>
            {Card}
          </Grid>
        );
      });

      return (
        <Grid container spacing={8}>
          <Grid item xs={6} md={8}>
            <Typography
              variant="title"
              className="title"
              style={{ textTransform: "capitalize" }}>
              {slug}
            </Typography>
          </Grid>

          <Grid item xs={6} md={4}>
            <Button
              colored="blue"
              raised
              fullWidth
              onClick={() => this.toggleOpen(true)}>
              Add
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={8}>
              {listItems}
            </Grid>
          </Grid>

          <FullDialog
            subtitle={this.props.dialog.subtitle}
            open={this.state.isOpen}
            onClose={() => this.toggleOpen(false)}
            onAction={this.handleAction}
            button={this.props.dialog.button}
            color="blue">
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <WrappedComponent
                  {...this.props}
                  handleClose={() => this.toggleOpen(false)}
                  handleChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </FullDialog>
        </Grid>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/library/pages/withPage.js